import store from '../store/index'

export function tienePermiso(target) 
{
  let permisos = store.getters['sesion/getPermisos']

  // si se encontraron permisos en el store, pruebo recuperarlos del local storage
  if(permisos.length === 0)
  {
    // recupero el token
    let tokenName = 'SistemaPedidoToken'
    let token = JSON.parse(localStorage.getItem(tokenName))

    // leo los permisos visuales del token
    if(token !== null)
    {
      permisos = token.PermisosVisuales
    }

    // valido que los permisos no queden undefined
    if(permisos === undefined)
    {
      permisos = []
    }
  }
  
  // busco el permiso con el target solicitado
  let p = permisos.find(x => { if(x.ComponenteVisual === target) return x })

  // por defecto el usuario tiene permiso para ver todos los componentes visuales
  return p === undefined
}